// luxon 기준
export const preferredDateFormatCandidates = Object.freeze([
  "yyyy-MM-dd",           // Rails date picker default
  "yyyy-MM-dd HH:mm:ss",  // Rails datetime default
  "yyyy-MM-dd HH:mm",     // Rails datetime without seconds
  "yyyy-MM-dd'T'HH:mm:ss", // ISO format
  "yyyy-MM-dd'T'HH:mm",   // ISO format without seconds
  "HH:mm",                // Time input format
  "HH:mm:ss",             // Time with seconds
  "yyyy/MM/dd",           // Common Korean date format
  "yyyy/MM/dd HH:mm:ss",
  "yyyy/MM/dd HH:mm",
  "yyyy.MM.dd",           // Korean date format with dots
  "yyyy.MM.dd HH:mm:ss",
  "yyyy.MM.dd HH:mm",
  "yyyyMMdd",             // Compact date format
  "yyyyMMddHHmmss",       // Compact datetime format
  "MM/dd/yyyy HH:mm:ss",  // US format
  "MM/dd/yyyy",
  "dd-MM-yyyy HH:mm:ss",  // European format
  "dd-MM-yyyy",
])
